module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDE0IDE0Ij48ZGVmcz48c3R5bGU+LmF7ZmlsbDojMzU0ZWNlO30uYntmaWxsOiNmZmY7fTwvc3R5bGU+PC9kZWZzPjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKC05MzMgLTI2MCkiPjxyZWN0IGNsYXNzPSJhIiB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHJ4PSI3IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg5MzMgMjYwKSIvPjxwYXRoIGNsYXNzPSJiIiBkPSJNMy41NTYsOFY0LjQ0NEgwVjMuNTU2SDMuNTU2VjBoLjg4OFYzLjU1Nkg4di44ODhINC40NDRWOFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDk0MCAyNjEuMzQzKSByb3RhdGUoNDUpIi8+PC9nPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/del.svg
// module id = fcOW
// module chunks = 1